import { createContext, useState } from "react";

export const CustomerMenuContext = createContext({});
export const CustomerMenuProvider = ({ children }) => {
  const [customerMenuContext, setCustomerMenuContext] = useState({});
  const getMenu = async (hotelID) => {
    const requestObject = {
      hotelID: hotelID,
    };
    const response = await fetch(
      "https://glistening-mochi-9809d3.netlify.app/.netlify/functions/api/menu/getmenu",
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify(requestObject),
      }
    );
    const result = await response.json();
    var tempObject = {};
    Object.keys(result).map((index) => {
      if (index !== "_id") {
        tempObject = { ...tempObject, [index]: result[index] };
      }
    });
    setCustomerMenuContext({ ...tempObject });
  };
  const value = { customerMenuContext, getMenu };
  return (
    <CustomerMenuContext.Provider value={value}>
      {children}
    </CustomerMenuContext.Provider>
  );
};
